module.exports = __webpack_public_path__ + "media/images/bg-main-20b07716d66b521d728d10da82f76816.png";